import { createSlice } from '@reduxjs/toolkit';
import { IMessageState } from 'interface/message/messageInfo';
import { RootState } from 'store/rootReducer';

const initialState: IMessageState = {
  open: false,
  options: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 2000000,
    message: '',
    variant: 'success',
  },
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    showMessage: (state, action) => {
      state.open = true;
      state.options = {
        ...initialState.options,
        ...action.payload,
      };
    },
    hideMessage: state => {
      state.open = false;
    },
  },
});

export const { showMessage, hideMessage } = messageSlice.actions;
export default messageSlice.reducer;

export const messageSelector = (state: RootState): IMessageState => state.message;
